import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ModelManagementComponent } from './model-management/model-management.component';
import { MsalGuard } from '@azure/msal-angular';
import { OverageComponent } from './overage/overage.component';
import { GroupGuardService } from './services/group-guard.service';
import { ConfigureModelListComponent } from './configure-model-list/configure-model-list.component';
import { environment } from 'src/environments/environment';

let enValue = environment;

const routes: Routes = [
  {
    path: 'overage',
    component: OverageComponent,
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'modelManagement',
    component: ModelManagementComponent,
    canActivate: [
      MsalGuard,
      GroupGuardService
    ],
    data: {
      expectedGroups: [
        enValue.groups_client_PlatformAdminGroupId,
        enValue.groups_client_ModelMgmtUserGroupId
      ]
    }
  },
  {
    path: 'configureModel',
    component: ConfigureModelListComponent,
    canActivate: [
      MsalGuard,
      GroupGuardService
    ],
    data: {
      expectedGroups: [
        enValue.groups_client_PlatformAdminGroupId,
        enValue.groups_client_ModelMgmtUserGroupId
      ]
    }
  },
  {
    path: '**',
    redirectTo: 'modelManagement',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes), RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
